import $, { service } from "./base";
function windDegreeToDir(wd) {
  if (wd > 22.5 && wd <= 67.5) {
    return "东北风"; //东北
  } else if (wd > 67.5 && wd <= 112.5) {
    return "东风"; //东
  } else if (wd > 112.5 && wd <= 157.5) {
    return "东南风"; //东南
  } else if (wd > 157.5 && wd <= 202.5) {
    return "南风"; //南
  } else if (wd > 202.5 && wd <= 247.5) {
    return "西南风"; //西南
  } else if (wd > 247.5 && wd <= 292.5) {
    return "西风"; //西
  } else if (wd > 292.5 && wd <= 337.5) {
    return "西北风"; //西北
  } else if (wd > 337.5 || wd <= 22.5) {
    return "北风"; //北
  } else {
    return "无风向"; //无风向
  }
}
const dataHelper = (res) => {
  if (res.result === 1) {
    return {
      data: res.data.map((d) => {
        return {
          ...d,
          // tempf: d.tempf == "" ? d.tempf : ((d.tempf - 32)/1.8).toFixed(1),
          // tempinf: d.tempinf == "" ? d.tempinf :((d.tempinf - 32)/1.8).toFixed(1),
          // baromabsin:(d.baromabsin*33.863882).toFixed(1),
          // baromrelin:(d.baromrelin*33.863882).toFixed(1),
          // maxdailygust:(d.maxdailygust*0.447).toFixed(1),
          // windgustmph:(d.windgustmph*0.447).toFixed(1),
          // windspeedmph:(d.windspeedmph*0.447).toFixed(1),
          // windspdmph_avg2m:(d.windspdmph_avg2m*0.447).toFixed(1),
          // windspdmph_avg10m:(d.windspdmph_avg10m*0.447).toFixed(1),
          // minutesrainin:(d.minutesrainin*25.4).toFixed(2),
          // hourlyrainin:(d.hourlyrainin*25.4).toFixed(2),
          // dailyrainin:(d.dailyrainin*25.4).toFixed(2),
          // weeklyrainin:(d.weeklyrainin*25.4).toFixed(2),
          // monthlyrainin:(d.monthlyrainin*25.4).toFixed(2),
          // yearlyrainin:(d.yearlyrainin*25.4).toFixed(2),
          // totalrainin:(d.totalrainin*25.4).toFixed(2),
          winddir10m: d.winddir_avg10m,
          winddir_avg10m:
            d.winddir_avg10m == "" ? "" : windDegreeToDir(d.winddir_avg10m),
        };
      }),
    };
  }
};
const dataHelper1 = (res) => {
  if (res.result === 1) {
    let d = res.data;
    return {
      ...d,
      // tempf: d.tempf == "" ? d.tempf : ((d.tempf - 32)/1.8).toFixed(1),
      // tempinf: d.tempinf == "" ? d.tempinf :((d.tempinf - 32)/1.8).toFixed(1),
      // baromabsin:(d.baromabsin*33.863882).toFixed(1),
      // baromrelin:(d.baromrelin*33.863882).toFixed(1),
      // maxdailygust:(d.maxdailygust*0.447).toFixed(1),
      // windgustmph:(d.windgustmph*0.447).toFixed(1),
      // windspeedmph:(d.windspeedmph*0.447).toFixed(1),
      // windspdmph_avg2m:(d.windspdmph_avg2m*0.447).toFixed(1),
      // windspdmph_avg10m:(d.windspdmph_avg10m*0.447).toFixed(1),
      // minutesrainin:(d.minutesrainin*25.4).toFixed(2),
      // hourlyrainin:(d.hourlyrainin*25.4).toFixed(2),
      // dailyrainin:(d.dailyrainin*25.4).toFixed(2),
      // weeklyrainin:(d.weeklyrainin*25.4).toFixed(2),
      // monthlyrainin:(d.monthlyrainin*25.4).toFixed(2),
      // yearlyrainin:(d.yearlyrainin*25.4).toFixed(2),
      // totalrainin:(d.totalrainin*25.4).toFixed(2),
      winddir10m: d.winddir_avg10m,
      winddir_avg10m:
        d.winddir_avg10m == "" ? "" : windDegreeToDir(d.winddir_avg10m),
    };
  }
};
export default {
  // 获取气象站列表
  getConnectData({
    value,
    time,
    startTime,
    endTime,
    device_name,
    device,
    webId,
  }) {
    return service.post("/connect/get/v2", {
      value,
      time,
      startTime,
      endTime,
      device_name,
      device,
      webId,
    });
  },
  // 获取气象站列表
  getDeviceList() {
    return $.get("/connect/getDeviceConnect/v2");
  },
  /**
   *
   * @param {*}  userId 用户ID，返回用户所属站点
   * @param {*}  status 设备状态
   * @param {*}  element 元素类型
   * @param {*}  specialUserId 用户ID,返回所有站点 区分是否属于用户站点
   * @returns
   */
  getDeviceDataList({
    userId,
    status,
    element,
    specialUserId,
    keyWord,
    deviceType,
  }) {
    return $.get("/connect/getDeviceData/v2", {
      params: {
        userId,
        status,
        element,
        specialUserId,
        keyWord,
        deviceType,
      },
    });
  },
  /**
   *
   * @param {*}  userId 用户ID，返回用户所属站点
   * @param {*}  status 设备状态
   * @param {*}  element 元素类型
   * @param {*}  specialUserId 用户ID,返回所有站点 区分是否属于用户站点
   * @returns
   */
  getNewDeviceDataList({
    userId,
    status,
    element,
    specialUserId,
    keyWord,
    deviceType,
    minLng,
    maxLng,
    minLat,
    maxLat,
  }) {
    return $.get("/connect/getNewDeviceData/v2", {
      params: {
        userId,
        status,
        element,
        specialUserId,
        keyWord,
        deviceType,
        minLng,
        maxLng,
        minLat,
        maxLat,
      },
    });
  },
  getDeviceTypeList() {
    return $.get("/connect/getDeviceTypeList");
  },
  followDevice({ device, userId }) {
    return $.get("/follow/add", { params: { device, userId } });
  },
  unfollowDevice({ device, userId }) {
    return $.get("/follow/remove", { params: { device, userId } });
  },
  getDevicesFollowCount(devices) {
    return $.get("/connect/getFollowedDeviceCountByIds", {
      params: { devices },
    });
  },
  getDeviceLatestData(device) {
    return $.get("/connect/getDeviceLastDataById/v2", { params: { device } });
  },
  getWeatherStationFollowList({ userId }) {
    return $.get("/connect/getWeatherStationFollowList", {
      params: { userId },
    });
  },
  getUserDeviceList({ userId }) {
    return $.get("/connect/getUserDeviceList", {
      params: { userId },
    });
  },
  getNearbyStationsKList({ lat, lng, webCode, userId }) {
    return $.get("/connect/getNearbyStationsKList", {
      params: { lat, lng, webCode, userId },
    });
  },
  getRecommendList({ userId }) {
    return $.get("/connect/getRecommendList", {
      params: { userId },
    });
  },
  // 分页获取气象站列表
  getConnectPage({
    device_name,
    currentUserName,
    page = 1,
    limit = 15,
    email,
    userId,
  }) {
    return service.post("/connect/page/v2", {
      device_name,
      currentUserName,
      page,
      limit,
      email,
      userId,
    });
  },
  // 获取单一气象站实时数据
  getDeviceData({ device, time, startTime, endTime }) {
    return service
      .post("/device_data/find/v2", {
        device,
        time,
        startTime,
        endTime,
      })
      .then(dataHelper1);
  },
  // 获取单一气象站历史数据
  getDeviceHourData({ device, time, startTime, endTime, period }) {
    return $.post("/device_data/hourData", {
      device,
      time,
      startTime,
      endTime,
      period,
    }).then(dataHelper);
  },
  // 新增气象站
  setConnectData(data) {
    return service.post("/connect/add/v2", data);
  },
  // 修改气象站
  upConnectData(data) {
    return service.post("/connect/upd/v2", data);
  },
  // 删除气象站
  delConnectData(id) {
    return service.post("/connect/del/v2", { id });
  },

  // 导出气象站数据
  expoetExcl(data) {
    return service.post("/device/stat/export/data/v2", data);
  },
  // 气象数据统计
  weatherDetail(data) {
    return service.post("/device/stat/stat/data/v2", data);
  },
  getMaxAndMinTem(params) {
    return service.get(
      "/statDay/list/v2?startTime=" +
        params.startTime +
        "&endTime=" +
        params.endTime +
        "&device=" +
        params.device,
    );
  },
  deviceInfo(device) {
    return service.get("/connect/getByDevice/v2?device=" + device);
  },
};

// 获取最高最低温
